const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBreast(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 443,
    height: 480,
    viewBox: "0 0 443 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PRSA PERJE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M203.3,300.9c4.2,1.5,8.2.4,9.9-2.8a10.14,10.14,0,0,0,.5-5.1c-.9-7-8.3-12-12.6-11.2",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.8,309.3c-4.3,6.2-8.1,5.8-11.9,4.9-13.4-3.3-6-21.6,3.5-25.6",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.7,293.3a21.37,21.37,0,0,0,1.4,18.6c3.2,5.4,8.5,7.8,13.2,5.8s7.9-7.7,8-14.5-3-13.2-7.6-16.1",
    style: {
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5,288.3a21.37,21.37,0,0,0,1.4,18.6c3.2,5.4,8.5,7.8,13.2,5.8s7.9-7.7,8-14.5-3-13.2-7.6-16.1",
    style: {
      fill: "#fff",
      fillRule: "evenodd",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.4,307.1c-3.5,5.1-6.4,4.9-9.3,4.2-10.3-2.4-4.3-17.6,3.2-21",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.5,292.2c5.1,1.5,10.1-.2,12.5-4.2,4.8-11.8-6.9-20.6-13.5-18.8",
    style: {
      fill: "#d00000",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.6,299.6c-5,7-9.3,6.6-13.7,5.5-15.4-3.7-6.9-24.5,4-29",
    style: {
      fill: "#d00000",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,279.9a23.84,23.84,0,0,0,1.6,21.1c3.7,6.2,9.8,8.8,15.3,6.6s9.1-8.7,9.2-16.5-3.4-15-8.8-18.2",
    style: {
      fill: "#d00000",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "bevel",
      strokeWidth: "1.3575999736785889px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.6,293.6c3.3,3.6,4.7,8,.9,9.5-1.4.2-3.9-.7-6.5-7-2.1-5.2-1.9-10.9-1.4-12.6C187.7,269.8,184.2,286.7,190.6,293.6Z",
    style: {
      fill: "#fcfcfc",
      fillRule: "evenodd",
      opacity: 0.3
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreast);
export default __webpack_public_path__ + "static/media/breast.806505a89000e7aa2d47729cf33a96ff.svg";
export { ForwardRef as ReactComponent };